import { render, staticRenderFns } from "./TripRoonTypeListItem.vue?vue&type=template&id=e31d8860&scoped=true&"
import script from "./TripRoonTypeListItem.vue?vue&type=script&lang=js&"
export * from "./TripRoonTypeListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripRoonTypeListItem.vue?vue&type=style&index=0&id=e31d8860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31d8860",
  null
  
)

export default component.exports